import { Button } from "@/components/ui/button";
import { MemberSetting } from "@/types/purchase";
import { LogIn } from "lucide-react";

interface SettingsManagerProps {
  user: any;
  memberSettings: MemberSetting[];
  memberSetting: MemberSetting;
  openLoginModal: () => void;
}

export function SettingsManager({
  user,
  memberSettings,
  memberSetting,
  openLoginModal
}: SettingsManagerProps) {
  
  // 비로그인 유저용 안내 메시지 컴포넌트
  const NonLoginSettingsPrompt = () => (
    <div className="flex flex-col items-center justify-center p-8 border-2 border-dashed border-blue-200 rounded-lg bg-blue-50">
      <div className="text-center space-y-3">
        <h3 className="text-lg font-medium text-blue-900">
          설정을 저장하고 더 편리하게 사용해보세요
        </h3>
        <p className="text-sm text-blue-600">
          배송비, 무료배송 기준 금액, 입금계좌 정보를 저장하여<br />
          다음에도 동일한 설정을 바로 불러올 수 있습니다
        </p>
        <Button
          variant="default"
          size="lg"
          onClick={openLoginModal}
          className="bg-blue-600 hover:bg-blue-700 text-white"
        >
          <LogIn className="mr-2 h-4 w-4" />
          로그인하고 설정 저장하기
        </Button>
      </div>
    </div>
  );

  return (
    <div className="space-y-6 mb-8">
      <div className="space-y-4">
        {user && memberSettings.length > 0 ? (
          memberSettings.map((setting) => (
            <div
              key={setting.id}
              className={`flex items-center justify-between p-4 rounded-lg border ${
                setting.id === memberSetting.id ? 'border-blue-500 bg-blue-50' : 'border-gray-200'
              }`}
            >
              <div className="flex-1">
                <h3 className="font-medium">{setting.settingName}</h3>
                <p className="text-sm text-gray-500 mt-1.5">
                  배송비: {setting.shippingFee.toLocaleString()}원{setting.shippingFeePresets.length > 0 && ` (다른 배송비: ${setting.shippingFeePresets.map((p) => p.toLocaleString()).join(' / ')}원)`} /
                  배송비 무료 기준 금액: {setting.freeShippingThreshold.toLocaleString()}원 /
                  제주/산간 배송비: {setting.jejuShippingFee.toLocaleString()}원{setting.jejuFreeShippingFee > 0 && ` (무료배송 시 ${setting.jejuFreeShippingFee.toLocaleString()}원)`} /
                  입금계좌: {setting.depositAccount} /
                  상품 목록 이모지: {setting.itemEmoji}
                </p>
              </div>
              <div className="flex gap-2 ml-6">
                <div className="text-sm px-3 py-1.5 bg-blue-50 text-blue-600 rounded-md border border-blue-200 font-medium">
                  현재 사용 중인 설정입니다
                </div>
              </div>
            </div>
          ))
        ) : user ? (
          // 로그인 상태이지만 저장된 설정이 없는 경우, 아무것도 표시하지 않음
          null
        ) : (
          // 비로그인 상태에만 안내 메시지 표시
          <NonLoginSettingsPrompt />
        )}
      </div>
    </div>
  );
} 